export interface ComparatorOption {
  label: string;
  value: string;
}

export const comparatorOptions: ComparatorOption[] = [
  {
    label: 'is equal to',
    value: 'EQUALS',
  },
  {
    label: 'is not equal to',
    value: 'NOT_EQUALS',
  },
  {
    label: 'contains',
    value: 'CONTAINS',
  },
  {
    label: 'does not contain',
    value: 'NOT_CONTAINS',
  },
  {
    label: 'is greater than',
    value: 'GT',
  },
  {
    label: 'is greater than or equal to',
    value: 'GTE',
  },
  {
    label: 'is less than',
    value: 'LT',
  },
  {
    label: 'is less than or equal to',
    value: 'LTE',
  },
  {
    label: 'is blank',
    value: 'EMPTY',
  },
  {
    label: 'is not blank',
    value: 'NOT_EMPTY',
  },
  {
    label: 'starts with',
    value: 'STARTS_WITH',
  },
  {
    label: 'does not start with',
    value: 'NOT_STARTS_WITH',
  },
  {
    label: 'ends with',
    value: 'ENDS_WITH',
  },
  {
    label: 'does not end with',
    value: 'NOT_ENDS_WITH',
  },
  {
    label: 'is not a valid date',
    value: 'INVALID_DATE',
  },
  {
    label: 'is a valid date',
    value: 'VALID_DATE',
  },
  {
    label: 'is a valid number',
    value: 'VALID_NUMBER',
  },
  {
    label: 'is not a valid number',
    value: 'INVALID_NUMBER',
  },
  {
    label: 'is one of',
    value: 'IN',
  },
];

export const defaultComparatorOptions: ComparatorOption[] = [
  { value: 'IN', label: 'is one of' },
  ...comparatorOptions.filter((o) => o.value !== 'IN'),
];

export interface AnalysisDimensionFilter {
  dimension_id: string;
  comparator: string;
  value?: string | string[];
}

export interface AnalysisMetricFilter {
  metric_id: string;
  comparator: string;
  value?: string | number;
}

export const metricComparatorOptions: ComparatorOption[] = [
  { value: 'GT', label: 'is greater than' },
  { value: 'GTE', label: 'is greater than or equal to' },
  { value: 'LT', label: 'is less than' },
  { value: 'LTE', label: 'is less than or equal to' },
  { value: 'EQUALS', label: 'is equal to' },
  { value: 'NOT_EQUALS', label: 'is not equal to' },
  { value: 'EMPTY', label: 'is blank' },
  { value: 'NOT_EMPTY', label: 'is not blank' },
];

